import axios, { AxiosResponse, isAxiosError } from 'axios';
import { ICurrentUserInformation, IUser, Role } from 'types';
import { Router } from 'vue-router';
import { ActionContext, createStore, StoreOptions } from 'vuex';
import endpointsList from './helpers/endpointsList';
import { Route } from './routes';

export interface IVueexState {
  language: string;
  userRoles?: Role[];
  supplierId?: string;
  userData?: IUser;
  currentProjectId?: string;
  currentDigitalizationProjectId?: string;
  isCurrentPatchNotePending: boolean;
}

const store: StoreOptions<IVueexState> = {
  state: {
    language: 'de',
    userRoles: [],
    supplierId: undefined,
    userData: undefined,
    isCurrentPatchNotePending: false,
  },
  actions: {
    async fetchCurrentUserInfo(
      context: ActionContext<IVueexState, IVueexState>,
      router: Router,
    ) {
      if (context.state.userData) return;
      try {
        const response: AxiosResponse<ICurrentUserInformation> =
          await axios.get(endpointsList.general.userData);
        const data = response.data;
        context.commit('setCurrentUserInfo', {
          userData: data.userData,
          supplierId: data.supplier?.toString(),
          userRoles: data.roles,
          isCurrentPatchNotePending: data.isCurrentPatchNotePending,
        });
      } catch (err) {
        if (isAxiosError(err) && err.response?.status === 403) {
          router.push({ name: Route.FORBIDDEN_VIEW });
        }
        throw err;
      }
    },
  },
  mutations: {
    setLang(state: IVueexState, payload: string) {
      state.language = payload;
    },

    setCurrentUserInfo(
      state: IVueexState,
      payload: {
        userData: ICurrentUserInformation['userData'];
        supplierId?: string;
        userRoles: ICurrentUserInformation['roles'];
        isCurrentPatchNotePending: boolean;
      },
    ) {
      state.userData = payload.userData;
      state.supplierId = payload.supplierId;
      state.userRoles = payload.userRoles;
      state.isCurrentPatchNotePending = payload.isCurrentPatchNotePending;
    },

    setIsCurrentPatchNotePending(state: IVueexState, isPending: boolean) {
      state.isCurrentPatchNotePending = isPending;
    },
  },
};

export default createStore(store);
